<template>
  <UBadge
    class="mt-2 dark:border-[#4C2D2E] dark:border dark:bg-[#2B1F20] dark:text-cardinal-50 self-start"
  >
    <slot></slot>
  </UBadge>
</template>
